export class Organisation {
  constructor() {
    this.id = "";
    this.name = "";
    this.createdBy = "";
  }
}
